import React from "react";
import { SkeletonBase } from "@foris/avocado-suite";
import { Header } from "@common/components";
import { useTranslation } from "react-i18next";
import useNavigationUrl from "@common/hooks/useNavigationUrl";
import css from "./detail.module.scss";
import cardDetailCss from "./cardDetail.module.scss";

const CardDetailSkeleton = () => {
  const { t } = useTranslation();
  const { adaptedHomeUrl } = useNavigationUrl();

  return (
    <div className={cardDetailCss.cardDetail}>
      <Header
        breadcrumbItems={[
          { title: t("home.breadcrumb.current"), path: adaptedHomeUrl() },
          { title: t("booking.title") },
        ]}
        title={t("booking.title")}
      />

      <div className={cardDetailCss.cardDetail_content}>
        <div className={cardDetailCss.contentHeader}>
          <SkeletonBase width="28px" height="28px" radius="100%" />
          <SkeletonBase width="130px" height="24px" />
        </div>

        {/* Detalles */}
        <div className={css.detail}>
          <header className={css.detail_header}>
            <div className={css.headerTitle}>
              <SkeletonBase className={css.headerTitle_text} width="135px" height="18px" />
              <SkeletonBase width="80px" height="16px" radius="8px" />
            </div>

            <SkeletonBase width="145px" height="28px" />
          </header>

          <section className={css.detail_resume}>
            <div className={css.resumeItem}>
              <SkeletonBase className={css.resumeItem_label} width="85px" height="16px" />
              <SkeletonBase className={css.resumeItem_value} width="100px" height="16px" />
            </div>
          </section>

          <section className={css.detail_resume}>
            <div className={css.resumeItem}>
              <SkeletonBase className={css.resumeItem_label} width="35px" height="16px" />
              <SkeletonBase className={css.resumeItem_value} width="100px" height="16px" />
            </div>

            <div className={css.resumeItem}>
              <SkeletonBase className={css.resumeItem_label} width="70px" height="16px" />
              <SkeletonBase className={css.resumeItem_value} width="100px" height="16px" />
            </div>
          </section>

          <section className={css.detail_resume}>
            <div className={css.resumeItem}>
              <SkeletonBase className={css.resumeItem_label} width="85px" height="16px" />
              <SkeletonBase className={css.resumeItem_value} width="240px" height="16px" />
            </div>
          </section>

          <SkeletonBase className={css.detail_editBtn} width="120px" height="36px" />
        </div>

        {/* Sala y horario */}
        <div className={css.detail}>
          <header className={css.detail_header}>
            <div className={css.headerTitle}>
              <SkeletonBase className={css.headerTitle_text} width="100px" height="18px" />
            </div>
          </header>

          <section className={css.detail_resume}>
            <div className={css.resumeItem}>
              <SkeletonBase className={css.resumeItem_label} width="70px" height="16px" />
              <SkeletonBase className={css.resumeItem_value} width="100px" height="16px" />
            </div>
            <div className={css.resumeItem}>
              <SkeletonBase className={css.resumeItem_label} width="70px" height="16px" />
              <SkeletonBase className={css.resumeItem_value} width="100px" height="16px" />
            </div>
            <div className={css.resumeItem}>
              <SkeletonBase className={css.resumeItem_label} width="70px" height="16px" />
              <SkeletonBase className={css.resumeItem_value} width="100px" height="16px" />
            </div>
            <div className={css.resumeItem}>
              <SkeletonBase className={css.resumeItem_label} width="70px" height="16px" />
              <SkeletonBase className={css.resumeItem_value} width="100px" height="16px" />
            </div>
            <div className={css.resumeItem}>
              <SkeletonBase className={css.resumeItem_label} width="70px" height="16px" />
              <SkeletonBase className={css.resumeItem_value} width="100px" height="16px" />
            </div>
          </section>

          <section className={css.detail_resume}>
            <div className={css.resumeItem}>
              <SkeletonBase className={css.resumeItem_label} width="100px" height="16px" />
              <SkeletonBase className={css.resumeItem_value} width="75px" height="16px" />
            </div>
          </section>

          <section className={css.detail_resume}>
            <div className={css.resumeItem}>
              <SkeletonBase className={css.resumeItem_label} width="35px" height="16px" />
              <SkeletonBase className={css.resumeItem_value} width="110px" height="16px" />
            </div>
          </section>

          <SkeletonBase className={css.detail_editBtn} width="120px" height="36px" />
        </div>

        {/* Estado de la reserva */}
        <div className={css.detail}>
          <header className={css.detail_header}>
            <div className={css.headerTitle}>
              <SkeletonBase className={css.headerTitle_text} width="126px" height="18px" />
            </div>
          </header>

          <section className={css.detail_resume}>
            <div className={css.resumeItem}>
              <SkeletonBase className={css.resumeItem_label} width="45px" height="16px" />
              <SkeletonBase className={css.resumeItem_value} width="75px" height="16px" />
            </div>
          </section>

          <SkeletonBase className={css.detail_editBtn} width="120px" height="36px" />
        </div>
      </div>
    </div>
  );
};

export default CardDetailSkeleton;
